import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, map, startWith } from 'rxjs';
import { OfflineSyncService } from './offline-sync.service';

@Injectable({ providedIn: 'root' })
export class NetworkService {

  private onlineSubject = new BehaviorSubject<boolean>(navigator.onLine);
  public isOnline$ = this.onlineSubject.asObservable();

  constructor(private offlineSync: OfflineSyncService) {

    const online$ = fromEvent(window, 'online').pipe(map(() => true));
    const offline$ = fromEvent(window, 'offline').pipe(map(() => false));

    merge(online$, offline$)
      .pipe(startWith(navigator.onLine))
      .subscribe(status => {
        this.onlineSubject.next(status);

        if (status) {
          this.offlineSync.synchroniserAppels(); // OK, plus de boucle circulaire
        }
      });
  }
  
  isOnline(): boolean {
    return this.onlineSubject.value;
  }
}
